// extracted by mini-css-extract-plugin
export default {"CloseButton":"close-button_CloseButton__o3QFo"};